import { Navigation } from '@genesislcap/foundation-header';
import { customElement } from '@microsoft/fast-element';
import { NavTemplate as template } from '@genesislcap/foundation-header';
import { customHeaderStyles as styles } from './header.styles';

@customElement({
  name: 'custom-header',
  template,
  styles,
})
export class CustomHeader extends Navigation {}
